import React from 'react';
import PropTypes from 'prop-types';
import BootstrapPagination from 'react-bootstrap/Pagination';
import PaginationItem from './PaginationItem';

const Pagination = ({ path, currentPage, totalPages, nextPage, previousPage }) => {
    const LEFT_PAGE = "LEFT";
    const RIGHT_PAGE = "RIGHT";
    const pageNeighbours = 2;

    const range = (from, to, step = 1) => {
        let i = from;
        const range = [];

        while (i <= to) {
            range.push(i);
            i += step;
        }

        return range;
    };

    const fetchPageNumbers = () => {
        const totalNumbers = pageNeighbours * 2 + 3;
        const totalBlocks = totalNumbers + 2;

        if (totalPages > totalBlocks) {
            let pages = [];

            const leftBound = currentPage - pageNeighbours;
            const rightBound = currentPage + pageNeighbours;
            const beforeLastPage = totalPages - 1;

            const startPage = leftBound > 2 ? leftBound : 2;
            const endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage;

            pages = range(startPage, endPage);

            const pagesCount = pages.length;
            const singleSpillOffset = totalNumbers - pagesCount - 1;

            const leftSpill = startPage > 2;
            const rightSpill = endPage < beforeLastPage;

            const leftSpillPage = LEFT_PAGE;
            const rightSpillPage = RIGHT_PAGE;

            if (leftSpill && !rightSpill) {
                const extraPages = range(startPage - singleSpillOffset, startPage - 1);
                pages = [leftSpillPage, ...extraPages, ...pages];
            } else if (!leftSpill && rightSpill) {
                const extraPages = range(endPage + 1, endPage + singleSpillOffset);
                pages = [...pages, ...extraPages, rightSpillPage];
            } else if (leftSpill && rightSpill) {
                pages = [leftSpillPage, ...pages, rightSpillPage];
            }

            return [1, ...pages, totalPages];

        }

        return range(1, totalPages);
    }

    const renderPagination = pages => {
        let items = [];
        pages.map((page, index) => {
            if (page === LEFT_PAGE) {
                return items.push(
                    <PaginationItem
                        key={index}
                        to={`${path}/?page=${previousPage}`}
                        disabled={true}
                        type="dots"
                    />
                )
            }

            if (page === RIGHT_PAGE) {
                return items.push(
                    <PaginationItem
                        key={index}
                        to={`${path}/?page=${nextPage}`}
                        disabled={true}
                        type="dots"
                    />
                )
            }

            return typeof page === 'number' && items.push(<PaginationItem
                key={index}
                active={page === Number(currentPage)}
                to={`${path}?page=${page}`}
                label={page}
            />)

        })

        return items;
    }


    const pages = fetchPageNumbers();

    return (
        <div className="pagination__container">
            <BootstrapPagination>
                {renderPagination(pages)}
            </BootstrapPagination>
        </div>
    );
};

Pagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
};

export default Pagination;
